export const getDefaultMenu = () => [
  {
    id: 1,
    path: "/dashboard",
    name: "Dashboard",
    iconOffHover: (
      <i className="fa fa-dashboard" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 2,
    path: "/product-management",
    name: "Product Management",
    iconOffHover: (
      <i className="fab fa-product-hunt" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 3,
    path: "/user-list",
    name: "User Management",
    iconOffHover: <i className="fa fa-user" style={{ fontSize: "1.2rem" }} />,
    className: "pro_options",
  },
  // {
  //   id:4,
  //   path: "/customers-list",
  //   name: "Retailer Management",
  //   iconOffHover: <i className="fa fa-user" style={{ fontSize: "1.2rem" }} />,
  //   className: "pro_options",
  // },
  {
    id: 5,
    name: "QR Management",
    iconOffHover: <i className="fa fa-qrcode" style={{ fontSize: "1.2rem" }} />,
    className: "pro_options",
    dropdown: [
      {
        path: "/qrcode-template",
        name: "QR Template",
      },
      {
        path: "/qr-code-logs",
        name: "Download QR Code",
      },
      {
        path: "/qrcode-list",
        name: "QR Code Status",
      },
    ],
  },
  {
    id: 6,
    path: "/receipt",
    name: "Customer Request",
    iconOnHover: (
      <i className="fa-solid fa-receipt" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 7,
    path: "/vouchers",
    name: "Voucher List",
    iconOffHover: (
      <i className="fa-solid fa-ticket" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 8,
    path: "/kyc",
    name: "KYC Management",
    iconOffHover: (
      <i className="fas fa-id-card" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 9,
    path: "/my-campaign",
    name: "Promotions Schemes",
    iconOffHover: <i className="fas fa-poll" style={{ fontSize: "1.2rem" }} />,
    className: "pro_options",
  },
  // {
  //   id: 10,
  //   path: "/orders",
  //   name: "Customer Orders",
  //   iconOnHover: (
  //     <i className="fa-solid fa-receipt" style={{ fontSize: "1.2rem" }} />
  //   ),
  //   className: "pro_options",
  // },
  {
    id: 11,
    path: "/invoice",
    name: "Invoice Management",
    iconOffHover: (
      <i className="fa fa-file-invoice" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 12,
    path: "/transactions-list",
    name: "Transaction",
    iconOffHover: (
      <i className="fa-solid fa-exchange" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  {
    id: 13,
    path: "/redemptions-list",
    name: "Redemption",
    iconOffHover: (
      <i className="fa-solid fa-hand-holding-dollar" style={{ fontSize: "1.2rem" }} />
    ),
    className: "pro_options",
  },
  // {
  //   id:14,
  //   path: "/support",
  //   name: "Retailer Request",
  //   iconOnHover: <i className="fa-solid fa-receipt" style={{ fontSize: "1.2rem" }} />,
  //   className: "pro_options",
  // },
  {
    id: 14,
    path: "/settings",
    name: "Settings",
    iconOffHover: <i className="fa fa-cog" style={{ fontSize: "1.2rem" }} />,
    className: "pro_options",
  },
];
